// extracted by mini-css-extract-plugin
module.exports = {"Error":"styles_Error__2_-J6","ErrorWrapper":"styles_ErrorWrapper__GwYJY","ErrorImg":"styles_ErrorImg__1viNg","ErrorTitle":"styles_ErrorTitle__3xTOz"};